<section class="circle-gradient-1">
    <div class="circle-gradient overflow-hidden">
        <div class="breadcrumb-sec event-sec">
            <div class="container">
                <div class="row g-0">
                    <div class="col-lg-6 col-md-6">
                        <ul class="breadcrumb">
                            <li><a routerLink="/">Home</a></li>
                            <li><i class="fa fa-angle-right"></i></li>
                            <li><a href="events">Events</a></li>
                            <li><i class="fa fa-angle-right"></i></li>
                            <li>Antaragni</li>
                        </ul>
                        <div class="sec-title">
                            <h1><span>Antaragni</span></h1>
                            <p>Lights. Colors. Culture. ✨ Antaragni Days brought out the vibrant spirit of GHRCACS Pune
                                — from traditional grace to modern grooves!</p>
                        </div>
                        <div class="breadcrumb-overlay overflow-hidden"
                            style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs1.webp);">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="circle-gradient-1">
    <div class="container">


        <div class="section-lg">
            <div class="sec-title text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="demo-gallery">
                <ul  appLightgallery>
                    <li class="grid-item1"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs.webp">
                        </a>
                    </li>
                    <li class="grid-item2"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs1.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs1.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs1.webp">
                        </a>
                    </li>
                    <li class="grid-item3 "
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs2.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs2.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs2.webp">
                        </a>
                    </li>
                    <!-- <li class="grid-item4 "
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs3.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs3.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/antarigini-ghrcacs3.webp">
                        </a>
                    </li> -->
                </ul>
            </div>
        </div>

    </div>
</section>
